import type { ReactNode } from 'react';

export const symbol_nightlight: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M593-80q-88 0-166.5-31.5t-137.87-86.56q-59.37-55.07-94-129.5Q160-402 160-488t34.5-161q34.5-75 94-130t138-86.5Q505-897 593-897q29.67 0 59.33 5.5Q682-886 711-876q10 3 15.5 11.2 5.5 8.21 5.5 16.8 0 6.12-2.5 11.56T722-826q-74 66-119 152.5T558-488q0 97.92 44 184.96T721-151q5 5 7.5 10.56 2.5 5.56 2.5 11.44 0 8.94-5 17.47T711-100q-29 10-58.52 15-29.53 5-59.48 5Zm0-60h26.42q12.58 0 20.58-1-66-74-104-162t-38-185q0-97 38-185t104-163q-8-1-20.58-1H593q-153 0-263 101.96t-110 247Q220-343 330-241.5T593-140Zm-95-349Z"
		/>
	</svg>
);
